import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  rootSubTabs: {
    textAlign: 'left',
  },
  tabs: {
    backgroundColor: theme.palette.common.white,
    marginRight: theme.spacing(4),
    borderTopRightRadius: theme.spacing(0.5),
    borderTopLeftRadius: theme.spacing(0.5),
    borderBottomStyle: 'inset',
    borderBottom: `solid 1px ${theme.palette.dividers.contrastText}`,
    paddingLeft: theme.spacing(1.7),
  },
  subComponents: {
    backgroundColor: theme.palette.common.white,
    padding: theme.spacing(1.5),
    borderRadius: theme.spacing(0, 0, 1, 1),
  },
  headerContent: {
    padding: theme.spacing(2.8, 0, 0, 1.6),
    display: 'flex',
  },
  checkIconFilled: {
    color: theme.palette.labraCheckbox.main,
    verticalAlign: 'middle',
    paddingTop: theme.spacing(0.25),
  },
  subTabsV2: {
    boxShadow: `0px -1px 0px 0px ${theme.palette.labraV2BoxShadow.dark} inset`,
    paddingLeft: theme.spacing(4),
  },
}))
